import { useForm } from '@/common/form/FormContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { useEffect, useMemo } from 'react';

export const CtrtOwnerCust = ({ fieldDef }) => {

    const { formValues, assignValue } = useForm();
    
    const ctrtTypeNoOwner = ['MCD', 'MPD']; 

    useEffect(() => {
      if (ctrtTypeNoOwner.includes(formValues.type)) {
        assignValue('ownerCustId', null);
        assignValue('ownerCustCode', null);
      }
    }, [formValues.type]);

    const updatedFieldDef = useMemo(() => {
      return {
        ...fieldDef,
        disabled: fieldDef.disabled || ctrtTypeNoOwner.includes(formValues.type),
        required: !ctrtTypeNoOwner.includes(formValues.type)
      };
    }, [formValues.type, fieldDef.disabled]);

  return <EntitySelect fieldDef={updatedFieldDef} />;
}